/**
 * Attribution Tracking System
 * Captures UTM parameters, referrer, session data
 */

const STORAGE_KEY = 'truintent_attribution';
const SESSION_KEY = 'truintent_session';

/**
 * Parse URL parameters
 */
function getUrlParams() {
  const params = new URLSearchParams(window.location.search);
  return {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_term: params.get('utm_term'),
    utm_content: params.get('utm_content'),
    gclid: params.get('gclid'), // Google Ads click ID
    fbclid: params.get('fbclid'), // Facebook click ID
  };
}

/**
 * Get or create session ID
 */
function getSessionId() {
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substring(7)}`;
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

/**
 * Get attribution data
 */
export function getAttribution() {
  // Check if we have stored attribution (first touch)
  let stored = null;
  try {
    const storedData = localStorage.getItem(STORAGE_KEY);
    if (storedData) {
      stored = JSON.parse(storedData);
    }
  } catch (e) {
    console.error('Error reading attribution:', e);
  }

  // Get current URL params
  const urlParams = getUrlParams();

  // Get referrer
  const referrer = document.referrer || null;

  // Build attribution object
  const attribution = {
    // First touch (if exists)
    first_touch: stored?.first_touch || {
      ...urlParams,
      referrer,
      landed_at: new Date().toISOString(),
    },

    // Last touch (current visit)
    last_touch: {
      ...urlParams,
      referrer,
      visited_at: new Date().toISOString(),
    },

    // Session info
    session_id: getSessionId(),

    // Page info
    landing_page: window.location.pathname,
    page_title: document.title,
  };

  // Store first touch if new visitor
  if (!stored) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(attribution));
    } catch (e) {
      console.error('Error storing attribution:', e);
    }
  }

  return attribution;
}

/**
 * Track page view
 */
export function trackPageView(funnelId, pageId) {
  const attribution = getAttribution();

  // Send to analytics endpoint (optional - implement if needed)
  if (window.plausible) {
    window.plausible('pageview', {
      props: {
        funnel_id: funnelId,
        page_id: pageId,
        utm_source: attribution.last_touch.utm_source,
        utm_campaign: attribution.last_touch.utm_campaign,
      }
    });
  }

  return attribution;
}

/**
 * Clear attribution (for testing)
 */
export function clearAttribution() {
  localStorage.removeItem(STORAGE_KEY);
  sessionStorage.removeItem(SESSION_KEY);
}
